export const REQUEST_ERROR = 'request_error';
export const NETWORK_ERROR = 'network_error';
export const VALIDATION_ERROR = 'invalid_input';
